import { DatePipe } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { tap } from 'rxjs';
import { MceApiService } from '../../../core/mceapi.client.generated';
import { FormDirective } from '../../../shared/directives/form.directive';
import { DateHelpers } from '../../../shared/functions/date.helpers';

interface Model { html: string, endDate: Date; }

@Component({
  selector: 'mce-motd',
  imports: [FormDirective, FormsModule, ReactiveFormsModule, 
    MatFormFieldModule, MatInputModule, MatButtonModule, MatDatepickerModule,
    MatProgressSpinnerModule],
  providers: [
    DatePipe,
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
  ],
  templateUrl: './motd.component.html',
  styleUrl: './motd.component.scss'
})
export class MotdComponent {

  private mceApiService = inject(MceApiService);

  motdResource = rxResource({
    stream: () =>
      this.mceApiService.v1SiteSettingsMotd().pipe(
        tap(data => {
          const endDate = data.endDate?.value;
          this.formValue.set({
            html: data.html ?? '',
            endDate: endDate === undefined ? new Date() : new Date(endDate)
          });
        }))
  });
  motd = computed(() => this.motdResource.value);

  formValue = signal<Model>({html: '', endDate: new Date()});
  formValid = signal<boolean>(false);
  formDirty = signal<boolean>(false);

  private readonly processing = signal(false);

  protected readonly viewModel = computed(() => {
    return {
      formValue: this.formValue(),
      showSpinner: this.processing(),
    };
  });

  protected get vm() { return this.viewModel(); }


  setMOTD() {
    this.processing.set(true);
    let motd = {
      html: this.formValue().html.trim(),
      endDate: { value: DateHelpers.toNormalisedUtcString(this.formValue().endDate) },
      uid: ''
    }
    this.mceApiService.v1SiteSettingsMotdUpdate(motd)
      .pipe(
        tap(() => this.processing.set(false))).subscribe();
  }

}
